export { SkillPunctual as default } from './SkillPunctual';
